// Import model
import { Entity } from '../models/Entity';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)
import { OrganizationSerializer } from './OrganizationSerializer';
import { UserSerializer } from './UserSerializer';

/**
 * Serializer for Entity - handles JSON serialization and deserialization with type validation
 */
export class EntitySerializer {
  /**
   * Deserializes a JSON string into a Entity instance
   */
  static deserialize(json: string): Entity {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Entity instance
   */
  static fromObject(obj: any): Entity {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Entity');
    }

    // Handle polymorphic deserialization using discriminator
    const discriminator = obj['_t'];

    switch (discriminator) {
      case 'Organization':
        return OrganizationSerializer.fromObject(obj);
      case 'User':
        return UserSerializer.fromObject(obj);
      default:
        // Fall through to base type deserialization
        break;
    }

    const instance: Entity = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      id: obj['_id'] as string | undefined,
      t: obj['_t'] as string,
      email: obj['email'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      timeZone: obj['timeZone'] as string | undefined,
      organizationId: obj['organizationId'] as string | undefined,
      organizationIdName: obj['organizationId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Entity instances
   */
  static deserializeArray(json: string): Entity[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Entity instance to a JSON string
   */
  static serialize(instance: Entity): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Entity instance to a plain object
   */
  static toObject(instance: Entity): any {
    return {
      'name': instance.name,
      'description': instance.description,
      '_id': instance.id,
      '_t': instance.t,
      'email': instance.email,
      'phone': instance.phone,
      'timeZone': instance.timeZone,
      'organizationId': instance.organizationId,
      'organizationId|Name': instance.organizationIdName,
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of Entity instances to a JSON string
   */
  static serializeArray(instances: Entity[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
